import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import useSiteMetadata from '../components/SiteMetadata';

function SEO({
  title,
  path,
  description = null,
  type = null,
  image = null,
  date = null,
}) {
  const { baseUrl } = useSiteMetadata();
  const url = baseUrl+path;

  let jsonType = "WebPage";
  let metaType = "website";
  if(type == 'research') {
    jsonType = "Report";
    metaType = "article";
  } else if(type == 'blog') {
    jsonType = "BlogPosting";
    metaType = "article";
  }

  const imageUrl = baseUrl + 
    (!!image.childImageSharp
      ? image.childImageSharp.gatsbyImageData.images.fallback.src
      : image);
      
  const JSONLD = {
    "@context": "https://schema.org",
    "@type": jsonType,
    "headline": title,
    "inLanguage": "en",
    "author": {
      "@type": "Organization",
      "name": "Global Disinformation Index",
      "url": "https://disinformationindex.org"
    },
    "url": url,
  };

  if(date)
    JSONLD["datePublished"] = date;

  if(description)
    JSONLD["abstract"] = description;

  if(image)
    JSONLD["image"] = [imageUrl];
  
  return (
    <Helmet>
      <title>{title}</title>
      {description && (
        <meta name="description" content={description} />
      )}
      <meta property="og:title" content={title} />
      <meta property="og:type" content={metaType} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
      {image && (
        <meta property="og:image" content={imageUrl} />
      )}

      <script type="application/ld+json">
        {JSON.stringify(JSONLD)}
      </script>
    </Helmet>
  );
}

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string,
  path: PropTypes.string,
  image: PropTypes.string,
  date: PropTypes.string,
};

SEO.defaultProps = {
  title: '',
  description: null,
  type: 'website',
  path: null,
  image: null,
  date: null,
};

export default SEO;
